module.exports = __webpack_public_path__ + "1.5.0-unryo/img/offline-unknown-3.0392628d.svg";